import React from 'react';
import UnderConstructionPage from './UnderConstructionPage';

export default function Outsourced() {
  return (
    <UnderConstructionPage
      title="Returns Outsourced"
      description="Phase 2: scaffold placeholders + navigation only."
    />
  );
}
